/** 引入Vue 库 */
import Vue from 'vue'

/** 引入index.vue */
import IndexVue from "./pages/index"

/** 引入路由配置文件 */
import router from './router/index'

/** 引入element-ui文件并注册 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

/** 控制权限方法 */
import { calcBtnShow, mzConfirm, GetLocalQxData, PageQxData, setDataCons } from './utils/Tool';
Vue.prototype.mzConfirm = mzConfirm;             //  再次确认弹窗

/** 全局组件 */
import global from './components/index';
Vue.use(global)

/** 引入apis */
import Api from './api/index'
Vue.prototype.$Api = Api

// import '@/assets/icon/iconfont.css'
/** 引入index.less */
import '@/styles/main'

import "default-passive-events"; //添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。 解决chrome下的warning问题
/** 引入时间库 */
import moment from "moment"; 
Vue.prototype.moment = moment
// 动态显示实时时间/时间格式化插件
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs; 

var baseUrl = 'https://ai.kbsdkj.cn'
Vue.prototype.$baseUrl = baseUrl

var wsUrl = 'wss://ai.kbsdkj.cn'
Vue.prototype.$wsUrl = wsUrl

import axios from 'axios'
axios.post(baseUrl+'/api/web/audio/application').then(res => {
    if (res.data.code === 200){
        let dateStr = atob(res.data.data)
        const expireDate = new Date(dateStr).getTime();
        const time = res.data.timestamp
        if(time >= expireDate){
            document.body.innerHTML = `
            <div style="text-align:center; padding:100px; font-family:sans-serif;color:#333;">
            <h2>应用已过期</h2>
            </div>
            `;
            throw new Error('');
        }
    }else{
        document.body.innerHTML = `
        <div style="text-align:center; padding:100px; font-family:sans-serif;color:#333;">
        <h2>${res.data.msg}</h2>
        </div>
        `;
        throw new Error('');
    }
}).catch(err => {
    console.log(err)
})

new Vue({
    el: '#app', 
    render(createElement) {
        let layout = this.$route.meta.layout
        layout = layout ? layout : this.$route.path === '/' ? '' : 'main-layout';
        return createElement(IndexVue, {props: {layout}})
    },
    router,
})

